module.exports = __webpack_public_path__ + "assets/img/limeclinic-1.8d84e6f5.png";